import { render, staticRenderFns } from "./ftp.vue?vue&type=template&id=4c57af9a&scoped=true&"
import script from "./ftp.vue?vue&type=script&lang=js&"
export * from "./ftp.vue?vue&type=script&lang=js&"
import style0 from "./ftp.vue?vue&type=style&index=0&id=4c57af9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57af9a",
  null
  
)

export default component.exports